import { Tooltip } from "antd";
import PhoneIcon from "common/icons/phoneGreen.svg";
import styled from "styled-components";

const TextContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const text = (
  <div>
    <TextContainer>Customer Care:</TextContainer>
    <TextContainer>+91 9347236212</TextContainer>
  </div>
);
const Img = styled.img`
  margin: 5px 0 0 0;
  width: 24px;
  height: 24px;
  @media (max-width: 1280px) {
    width: 21px;
    height: 21px;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-left: 1px solid rgba(0, 87, 84, 0.1);
  padding: 0 30px;
`;

export default function PhoneHeader() {
  return (
    <Container>
      <Tooltip title={text}>
        <Img src={PhoneIcon} />
      </Tooltip>
    </Container>
  );
}
